import { Product } from 'utils/helpers/product';

export const findSingleWeightItem = (product: Product): { option: string | null; quantity: number } | null => {
  if (product.Options?.length === 1) {
    return { option: product.Options[0], quantity: 1 };
  }
  return null;
};
